import { FC, useMemo } from 'react'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { formatRelativeDate } from 'helpers/dateTimeHelpers'
import { LinkedAccountBalanceNote } from 'components/features/pfm/LinkedAccountBalance/LinkedAccountBalanceNote'
import styles from 'components/features/pfm/LinkedAccountBalance/LinkedAccountBalanceAmount.styl'
import { LinkedAccountBalanceUpdating } from 'components/features/pfm/LinkedAccountBalance/LinkedAccountBalanceUpdating'

type LinkedAccountBalanceAmountProps = {
  account: NonNullable<MixedAccountsTableItem['account']>
  isLiveUpdate?: boolean
}
export const LinkedAccountBalanceAmount: FC<LinkedAccountBalanceAmountProps> = (props) => {
  const { account, isLiveUpdate } = props
  const {
    link_status,
    unlinked_at,
    updated_at,
    amount,
  } = account

  const isUnlinked = link_status === 'unlinked'

  const amountChild = useMemo(() => {
    if (isUnlinked) {
      return 'Unlinked'
    }

    if (amount !== null) {
      return formatUSCurrency(amount)
    }

    return null
  }, [isUnlinked, amount])

  const noteChild = useMemo(() => {
    if (!isUnlinked && isLiveUpdate) {
      return (
        <div className={ styles.liveUpdate }>
          <LinkedAccountBalanceUpdating />
        </div>
      )
    }

    const date = isUnlinked ? unlinked_at : updated_at
    if (!date) {
      return null
    }

    return (
      <span>as of { formatRelativeDate(date) }</span>
    )
  }, [isUnlinked, unlinked_at, updated_at, isLiveUpdate])


  return (
    <div className={ styles.linkedAccountBalanceAmount }>
      <div className={ styles.amount }>
        { amountChild }
      </div>
      <LinkedAccountBalanceNote>
        { noteChild }
      </LinkedAccountBalanceNote>
    </div>
  )
}
